import { PERMISSIONS } from "utils/data/enum";
import React, { ReactElement } from "react";
import { ensure } from "utils/shared";
import SerialNumberLookupIcon from "theme/icons/SerialNumberLookupIcon";
import PolicyManagementIcon from "theme/icons/PolicyManagementIcon";
import ExceptionsIcon from "theme/icons/ExceptionsIcon";
import PremiumReceivablesIcon from "theme/icons/PremiumReceivablesIcon";
import ReportsNavIcon from "theme/icons/ReportsNavIcon";
// import SerialNumberModifyIcon from "theme/icons/SerialNumberModifyIcon";
// import SerialNumberAssignIcon from "theme/icons/SerialNumberAssignIcon";

enum menuIds {
  menuHome = "HOME",
  menuSerialNumberLookup = "SERIAL_NUMBER_LOOKUP",
  menuSerialNumberAssign = "SERIAL_NUMBER_ASSIGN",
  menuSerialNumberModify = "SERIAL_NUMBER_MODIFY",
  menuSerialNumberPolicyInventory = "SERIAL_NUMBER_POLICY_INVENTORY",
  menuPolicyManagement = "POLICY_MANAGEMENT",
  menuExceptions = "EXCEPTIONS",
  menuPremiumReceivables = "PREMIUM_RECEIVABLES",
  menuReports = "REPORTS",
  menuProfileSettings = "PROFILE_SETTINGS",
  menuLogout = "LOGOUT",
  menuRedirectAdmin ="MENU_REDIRECT_ADMIN",
  menuRedirectPSP ="MENU_REDIRECT_ADMIN",
  menuRedirectMain ="MENU_REDIRECT_ADMIN",  
}

enum menuNames {
  lblMenuHome = "Home",
  lblMenuSerialNumberLookup = " Policy Lookup",
  lblMenuSerialNumberAssign = "Assign",
  lblMenuSerialNumberModify = "Modify",
  lblMenuProfileSettings = "Profile Settings",
  lblMenuLogout = "Logout",
  lblMenuComingSoon = "Coming soon",
  lblMenuPolicyInventory = "Policy Inventory",
  lblMenuPolicyManagement = "Policy Management",
  lblMenuExceptions = "Exceptions",
  lblMenuPremiumReceivables = "Premium Receivables",
  lblMenuReports = "Reports",
}

enum menuType {
  homeMenu = "HOME_MENU",
  mainMenu = "MAIN_MENU",
  subMenu = "SUB_MENU",
}

export type MenuDefinition = {
  menuId: string;
  menuName: string;
  url: string;
  disabled: boolean;
  rolloverIconUrl?: string;
  isVisibleInHeader: boolean;
  type: menuType;
  Icon?: ReactElement;
  HeaderIcon?: ReactElement;
  permissionCode?: PERMISSIONS[];
};

const menuDefinitions: Array<MenuDefinition> = [
  {
    type: menuType.homeMenu,
    menuId: menuIds.menuHome,
    menuName: menuNames.lblMenuHome,
    url: "/Home",
    disabled: false,
    rolloverIconUrl: "",
    isVisibleInHeader: true,
    Icon: undefined,
    HeaderIcon: undefined,
    permissionCode: undefined,
  },
  // {
  //   type: menuType.mainMenu,
  //   menuId: menuIds.menuSerialNumberLookup,
  //   menuName: menuNames.lblMenuSerialNumberLookup,
  //   url: "/inventoryLookup",
  //   disabled: false,
  //   rolloverIconUrl: "",
  //   isVisibleInHeader: true,
  //   Icon: <SerialNumberLookupIcon color="action" />,
  //   HeaderIcon: <SerialNumberLookupIcon width="25" height="25" color="primary" />,
  //   permissionCode: [PERMISSIONS.INV_LOOKUP_ACCESS],
  // },
  // {
  //   type: menuType.mainMenu,
  //   menuId: menuIds.menuSerialNumberAssign,
  //   menuName: menuNames.lblMenuSerialNumberAssign,
  //   url: "/inventoryAssign",
  //   disabled: false,
  //   rolloverIconUrl: "",
  //   isVisibleInHeader: true,
  //   Icon: <SerialNumberAssignIcon color="action" />,
  //   HeaderIcon: <SerialNumberAssignIcon width="25" height="25" color="primary" />,
  //   permissionCode: [PERMISSIONS.INV_ASSIGN_VIEW, PERMISSIONS.INV_ASSIGN_MODIFY],
  // },
  // {
  //   type: menuType.mainMenu,
  //   menuId: menuIds.menuSerialNumberModify,
  //   menuName: menuNames.lblMenuSerialNumberModify,
  //   url: "/inventoryModify",
  //   disabled: false,
  //   rolloverIconUrl: "",
  //   isVisibleInHeader: true,
  //   Icon: <SerialNumberModifyIcon color="action" />,
  //   HeaderIcon: <SerialNumberModifyIcon width="25" height="25" color="primary" />,
  //   permissionCode: [PERMISSIONS.INV_MODIFY_VIEW],
  // },
  {
    type: menuType.mainMenu,
    menuId: menuIds.menuSerialNumberPolicyInventory,
    menuName: menuNames.lblMenuPolicyInventory,
    url: "/policyInventory",
    disabled: false,
    rolloverIconUrl: "",
    isVisibleInHeader: true,
    Icon: <SerialNumberLookupIcon color="action" />, // TODO: ICON also need to modify for inventory policy, currently reuse inventory modify icon as placeholder
    HeaderIcon: <SerialNumberLookupIcon width="50" height="50" color="primary" />,
    permissionCode: [PERMISSIONS.INV_LOOKUP_ACCESS, PERMISSIONS.INV_LOOKUP_VIEW, PERMISSIONS.INV_ASSIGN_VIEW, PERMISSIONS.INV_ASSIGN_MODIFY, PERMISSIONS.INV_MODIFY_VIEW],
  },
  {
    type: menuType.mainMenu,
    menuId: menuIds.menuPolicyManagement,
    menuName: menuNames.lblMenuPolicyManagement,
    url: "/policyManagement",
    disabled: false,
    rolloverIconUrl: "",
    isVisibleInHeader: true,
    Icon: <PolicyManagementIcon color="action" />,
    HeaderIcon: <PolicyManagementIcon width="50" height="50" color="primary" />,
    permissionCode: [PERMISSIONS.PIP_PM_ACCESS],
  },
  {
    type: menuType.mainMenu,
    menuId: menuIds.menuExceptions,
    menuName: menuNames.lblMenuExceptions,
    url: "/exceptions",
    disabled: false,
    rolloverIconUrl: "",
    isVisibleInHeader: true,
    Icon: <ExceptionsIcon color="action" />,
    HeaderIcon: <ExceptionsIcon width="50" height="50" color="primary" />,
    permissionCode: [PERMISSIONS.PIP_EXCEPTIONS_ACCESS],
  },
  {
    type: menuType.mainMenu,
    menuId: menuIds.menuPremiumReceivables,
    menuName: menuNames.lblMenuPremiumReceivables,
    url: "/premiumReceivables",
    disabled: false,
    rolloverIconUrl: "",
    isVisibleInHeader: true,
    Icon: <PremiumReceivablesIcon color="action" />,
    HeaderIcon: <PremiumReceivablesIcon width="50" height="50" color="primary" />,
    permissionCode: [PERMISSIONS.PIP_PREMREC_ACCESS],
  },
  {
    type: menuType.mainMenu,
    menuId: menuIds.menuReports,
    menuName: menuNames.lblMenuReports,
    url: "/reports",
    disabled: false,
    rolloverIconUrl: "",
    isVisibleInHeader: true,
    Icon: <ReportsNavIcon color="action" />,
    HeaderIcon: <ReportsNavIcon width="50" height="50" color="primary" />,
    permissionCode: [PERMISSIONS.PIP_REPORTS_ACCESS],
  },
  {
    type: menuType.subMenu,
    menuId: menuIds.menuProfileSettings,
    menuName: menuNames.lblMenuProfileSettings,
    url: "/profile-settings",
    disabled: false,
    rolloverIconUrl: "",
    isVisibleInHeader: true,
  },
];

const getUrlByMenuId = (menuId: string) =>
  ensure(
    menuDefinitions.find((menuDefinition) => menuDefinition.menuId === menuId)
  ).url;

const getUrlByMenuName = (menuName: string) =>
  ensure(
    menuDefinitions.find(
      (menuDefinition) => menuDefinition.menuName === menuName
    )
  ).url;

const getMenuIdByMenuName = (menuName: string) =>
  ensure(
    menuDefinitions.find(
      (menuDefinition) => menuDefinition.menuName === menuName
    )
  ).menuId;

export {
  getMenuIdByMenuName,
  getUrlByMenuName,
  getUrlByMenuId,
  menuDefinitions,
  menuNames,
  menuIds,
  menuType,
};
